import React from "react";
import { useFeatureHook } from "./featureHook";

export const FeatureContainer = ({
  children,
  message = "Feature is disabled",
  requiredFeature,
  showHelp = true,
}) => {
  const [isAccessGranted] = useFeatureHook();
  const featureAccess = isAccessGranted(requiredFeature)
    ? "enabled"
    : "disabled";

  const helpMessageHtml = showHelp ? (
    <div className="feature__help has-text-centered">
      <span className="feature__help__icon">
        <svg
          width="2rem"
          height="2rem"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </span>
      <p className="feature__help__message">{message}</p>
      <p className="feature__help__hint">
        Contact your administrator if you wish to use this feature.
      </p>
    </div>
  ) : (
    ""
  );

  return (
    <div className={`feature feature--${featureAccess}`}>
      <div className="feature__box">{children}</div>
      {helpMessageHtml}
    </div>
  );
};
